import { FiX } from 'react-icons/fi';
import AvailabilityTimer from './AvailabilityTimer';

/**
 * Modal shown to drivers when a rider cancels an accepted ride.
 * Displays the rider's name, a message, and the availability timer
 * so the driver can adjust their next available time.
 */
function RideCanceledModal({ riderName, onClose }) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60">
      <div className="bg-gradient-to-b from-main-blue-dark to-[#021a2a] rounded-2xl shadow-2xl mx-4 w-full max-w-md p-6 border border-main-light-highlight/20">
        {/* Header */}
        <div className="text-center mb-5">
          <div className="w-14 h-14 mx-auto mb-3 rounded-full bg-main-red-dark/20 border border-main-red-light/30 flex items-center justify-center">
            <FiX size={28} className="text-main-red-light" />
          </div>
          <h3 className="text-white text-xl font-bold mb-2">Ride Canceled</h3>
          <p className="text-main-light-highlight text-sm">
            Sorry, <span className="text-white font-semibold">{riderName}</span> has canceled the ride.
          </p>
          <p className="text-main-light-highlight text-sm mt-1">
            Would you like to adjust your next available time?
          </p>
        </div>

        {/* Availability Timer */}
        <div className="bg-main-blue-dark/40 rounded-xl p-4 mb-5 border border-main-light-highlight/10">
          <AvailabilityTimer />
        </div>

        {/* Close Button */}
        <button
          onClick={onClose}
          className="w-full py-3 rounded-xl bg-main-blue-light/30 hover:bg-main-blue-light/50 text-white font-medium transition-colors border border-main-light-highlight/20"
        >
          Close
        </button>
      </div>
    </div>
  );
}

export default RideCanceledModal;
